// extracted by mini-css-extract-plugin
export var center = "_x-2";
export var clickableRow = "_x-5";
export var expandedRow = "_x-7";
export var hoverable = "_x-4";
export var left = "_x-1";
export var right = "_x-3";
export var row = "_x-0";
export var selectedRow = "_x-6";
export var summaryRow = "_x-8";